<template>
  <v-dialog :value="active" :lazy="true" persistent max-width="800px">
    <v-card >
        <v-toolbar tabs card color="primary" dark>
          <v-spacer></v-spacer>
          <v-toolbar-title>{{$t('gameVersions.addTitle')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <template v-slot:extension>
            <v-tabs
              v-model="tab"
              color="primary"
              grow
            >
              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab>
                {{$t('gameVersions.addNew')}}
              </v-tab>
              <v-tab>
                {{$t('gameVersions.addFromVersion')}}
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-card-text>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-form ref="addNewForm" @submit.prevent="addNew()">
                <v-container grid-list-md>
                  <v-layout wrap >
                      <v-flex xs12>
                        <v-text-field
                          :label="$t('gameVersions.name')"
                          v-model="addNewData.name"
                          :rules="[v => !!v || $t('fields.required')]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          class="mt-0 mb-2"
                          hide-details
                          :label="$t('gameVersions.dd')"
                          v-model="addNewData.dd"
                        ></v-switch>
                      </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-tab-item>
            <v-tab-item>
              <v-form ref="addFromVersionForm" @submit.prevent="addFromVersion()">
                <v-container grid-list-md>
                  <v-layout wrap >
                    <v-flex xs12>
                        <v-text-field
                          :label="$t('gameVersions.name')"
                          v-model="addFromVersionData.name"
                          :rules="[v => !!v || $t('fields.required')]"
                        ></v-text-field>
                      </v-flex>
                    <v-flex xs12>
                      <v-autocomplete
                        :label="$t('gameVersions.versionToDuplicate')"
                        item-text="name"
                        item-value="_id"
                        v-model="addFromVersionData.gameVersion"
                        :items="$store.state.gameVersions.list"
                        :rules="[v => !!v || $t('fields.required')]"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="$store.state.gameVersions.loading"
            @click.native="add"
            flat
          >{{$t('general.add')}}</v-btn>
          <v-btn
            color="secondary"
            :disabled="$store.state.gameVersions.loading"
            submit
            flat
            @click.native="$emit('closedialog')"
          >{{$t('general.close')}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "GameVersionAdd",
  props: { active: Boolean },
  data() {
    return {
      tab: null,
      addNewData: {
        name: "",
        dd: false
      },
      addFromVersionData: {
        name: "",
        gameVersion: ""
      },
      rules: {
        required: value => !!value || this.$t('fields.required')
      }
    };
  },
  methods: {
    async init() {
      await this.$nextTick()
      this.$refs.addNewForm.reset();
      this.$refs.addFromVersionForm.reset();
    },
    async add() {
      if (this.tab === 0) {
        this.addNew()
      } else {
        this.addFromVersion()
      }
    },
    async addNew() {
      if (this.$refs.addNewForm.validate()) {
        if (await this.$store.dispatch("gameVersions/addNew", this.addNewData)){
          this.$emit('closedialog')
        }
      }
    },
    async addFromVersion() {
      if (this.$refs.addFromVersionForm.validate()) {
        if (await this.$store.dispatch("gameVersions/duplicate", this.addFromVersionData)){
          this.$emit('closedialog')
        }
      }
    }
  },
  computed: {},
  watch: {
    active(val) {
      if (val) {
        this.init()
      }
    }
  }
};
</script>
<style>
</style>

